import { useEffect, useState } from 'react';
import type { MarineOrganizationAccess } from './AuthGate';
import { supabase } from './lib/supabase';
import BrokerageWorkspaceV4 from './BrokerageWorkspaceV4';
import ListingSalesCockpitBridge from './ListingSalesCockpitBridge';
import CallModeDismissGuard from './CallModeDismissGuard';
import BrokerageWebsiteSyncBridge from './BrokerageWebsiteSyncBridge';
import ShowingsCalendarBridge from './ShowingsCalendarBridge';
import DealDeskBridge from './DealDeskBridge';
import BusinessSuiteBridge from './BusinessSuiteBridge';
import DocumentPdfBridge from './DocumentPdfBridge';
import ExternalBoatsBridge from './ExternalBoatsBridge';
import CalendarQuickCaptureBridge from './CalendarQuickCaptureBridge';
import './listing-sales-cockpit-bridge.css';
import './call-mode-fix.css';

export default function BrokerageWorkspaceV8({organization}:{organization:MarineOrganizationAccess}){
  const [revision,setRevision]=useState(0);
  const [calendarRevision,setCalendarRevision]=useState(0);
  const refresh=()=>setRevision(value=>value+1);
  const refreshCalendar=()=>{
    const wasOpen=document.body.classList.contains('marine-showings-calendar-open');
    setCalendarRevision(value=>value+1);
    if(wasOpen)window.setTimeout(()=>document.querySelector<HTMLButtonElement>('.showings-calendar-nav-button')?.click(),120);
  };
  useEffect(()=>{
    if(!supabase)return;
    const channel=supabase.channel(`marine-showings-${organization.id}`).on('postgres_changes',{event:'*',schema:'public',table:'marine_listing_showings',filter:`organization_id=eq.${organization.id}`},()=>refreshCalendar()).subscribe();
    return()=>{void supabase.removeChannel(channel)};
  },[organization.id]);
  return <>
    <BrokerageWorkspaceV4 key={`workspace-${revision}`} organization={organization}/>
    <ListingSalesCockpitBridge key={`cockpit-${revision}`} organization={organization}/>
    <BrokerageWebsiteSyncBridge organization={organization} onSynced={refresh}/>
    <ShowingsCalendarBridge key={`calendar-${calendarRevision}`} organization={organization}/>
    <CalendarQuickCaptureBridge organization={organization} onSaved={refreshCalendar}/>
    <ExternalBoatsBridge organization={organization}/>
    <DealDeskBridge organization={organization}/>
    <BusinessSuiteBridge organization={organization}/>
    <DocumentPdfBridge organizationId={organization.id}/>
    <CallModeDismissGuard/>
  </>;
}
